import {NgModule} from '@angular/core';
import {ClaimsComponent} from '../components/pages/claims/claims.component';
import {GreydomCommonModule} from '../../common/modules/greydom-common.module';
import {SubmitClaimViewComponent} from '../components/pages/submit-claim-view/submit-claim-view.component';
import {
  MemberPolicyProductLinkComponent
} from '../components/pages/case-shared-steps/member-policy-product-link/member-policy-product-link.component';
import {NgOptimizedImage} from '@angular/common';

const components: any[] = [
  ClaimsComponent,
  SubmitClaimViewComponent,
  MemberPolicyProductLinkComponent,
];

@NgModule({
  declarations: [...components],
    imports: [GreydomCommonModule, NgOptimizedImage],
  exports: [...components]
})

export class ClmPartialModule {
}
